module.exports = __webpack_public_path__ + "static/media/landing-mobile.ee5a4541.svg";